import { Loader2 } from 'lucide-react';

export const PAYMENT_MODES = [
  { value: 'cash', label: 'Cash' },
  { value: 'upi', label: 'UPI' },
];

export const statusBadge = (status) => {
  const map = {
    OCR_PENDING: 'bg-blue-50 text-blue-800 border-blue-200',
    HUMAN_REVIEW: 'bg-orange-50 text-orange-800 border-orange-200',
    PENDING: 'bg-amber-50 text-amber-800 border-amber-200',
    APPROVED: 'bg-green-50 text-green-700 border-green-200',
    REJECTED: 'bg-red-50 text-red-700 border-red-200',
  };
  return map[status] || 'bg-gray-50 text-gray-600 border-gray-200';
};

export const statusLabel = (status) => {
  const map = {
    OCR_PENDING: 'AI reading receipt',
    HUMAN_REVIEW: 'Human review',
    PENDING: 'Pending',
    APPROVED: 'Approved',
    REJECTED: 'Rejected',
  };
  return map[status] || status;
};

export const aiReviewLabel = (ocrStatus) => {
  const map = {
    PENDING: 'Queued',
    PROCESSING: 'AI reading…',
    PASSED: 'AI passed',
    FAILED: 'AI failed',
    ERROR: 'AI error',
  };
  return map[ocrStatus] || ocrStatus || '—';
};

export const OcrReadingHint = () => (
  <div className="mt-1.5 flex items-start gap-1.5 max-w-[260px] text-[11px] leading-snug text-blue-700">
    <Loader2 className="w-3.5 h-3.5 mt-0.5 shrink-0 animate-spin" />
    <span>AI is reading your receipt. Result will come soon.</span>
  </div>
);
